<template>
  <div class="section" :class="{ 'section--compact': !summary }">
    <div class="section__overlay"></div>
    <div class="section__wrapper">
      <checkout-stepper :steps="steps"></checkout-stepper>
    </div>
    <div class="section__wrapper">
      <div class="section__block">
        <div class="container container--lt-l--linear">
          <div class="container__main">
            <div class="group group--vertical" v-show="messages">
              <template v-for="(group, type) in messages">
                <template v-for="(message, index) in group">
                  <div class="group__item" :key="'message_' + type + index">
                    <div :class="'label label--' + type + '-inverted'">
                      {{ message }}
                    </div>
                  </div>
                </template>
              </template>
              <div class="section__spacer"></div>
            </div>
            <div class="form" v-if="currentStep">
              <p class="form__text" v-show="currentStep.textBefore">
                {{ currentStep.textBefore }}
              </p>
              <checkout-details
                v-show="showDetails"
                :details="details"
                :fields="fields"
                :offer="offer"
              >
              </checkout-details>

              <component
                v-for="field in currentFields"
                :field="field"
                :is="'checkout-field-' + field.type"
                :key="field.name"
              >
              </component>
              <p class="form__text" v-show="currentStep.textAfter">
                {{ currentStep.textAfter }}
              </p>
              <div class="section__spacer"></div>
              <checkout-navigation :steps="steps"></checkout-navigation>
            </div>
          </div>
          <div class="container__sidebar" v-if="summary">
            <checkout-summary
              :fields="fields"
              :json="json"
              :offer="offer"
              :summary="summary"
            >
            </checkout-summary>
          </div>
        </div>
      </div>
    </div>
    <div class="section__spacer"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as components from ".";

import sample from '../sample-data2.json'
import axios from 'axios'

export default {
  props: ['json'],
  name: 'checkout-main',
  computed: {
    ...mapState(['details', 'fields', 'messages', 'offer', 'steps', 'summary']),
    currentFields: function() {
      return this.fields
        .filter((field) => this.currentStep.fieldNames.includes(field.name))
        .filter((field) => !field.disabled)
    },
    currentIndex: function() {
      return Math.max(
        this.steps.findIndex((step) => step.active),
        0
      )
    },
    currentStep: function() {
      return this.steps[this.currentIndex]
    },
    showDetails: function() {
      return this.currentStep === this.steps.slice(-1)[0]
    },
  },
  methods: {
    loadState: function() {
      this.$store.dispatch('loadState', {
        newState: this.json || sample,
      })
    },
    saveState: function() {
      this.$store.dispatch('saveState')
    },
    // magicRetrieveState: async function() {
    //   const netzToken = new URL(window.location.href).searchParams.get(
    //     "netzToken"
    //   );
    //   if (netzToken) {
    //     const url = new URL(
    //       window.location.origin + this.json.api.magicRetrieve
    //     );
    //     url.searchParams.set("netzToken", netzToken);
    //     const result = await axios.get(url.href);
    //     const newState = result.data && result.data.body;
    //     console.log("magicRetrieve", { newState });
    //     if (
    //       newState &&
    //       typeof newState == "object" &&
    //       Object.keys(newState).length
    //     ) {
    //       await this.$store.dispatch("loadState", {
    //         newState
    //       });
    //     }
    //   }
    // }
  },
  mounted() {
    this.loadState()
    // this.magicRetrieveState();
  },
}
</script>
